/**
 * Created by Administrator on 2017/8/16.
 */
import common from './common';

export default {
    install: function(Vue) {
        Object.defineProperty(Vue.prototype, '$common', { value: common });
    }
}
